<div class="container">
  @for (tab of tabs(); track $index) {
  <a role="tab" class="container-tab" [class.is-active]="tab.selected" [style.color]="tab.color" (click)="switchTab(tab)">
    @if (tab.icon) {
      <ui-inline-svg [name]="tab.icon" class="container-tab-icon"></ui-inline-svg>
    }
    {{ tab.name | transloco }}
  </a>
  }
</div>
